/**
 * Simple passthrough component for routing.
 * (Motion animations removed to prevent stutter during heavy WebGL startup).
 */
export default function PageTransition({ children }) {
    return <>{children}</>;
}
